import { withStyles } from '@material-ui/core';
import Search from './Search';
import styles from './Search.styles';

export default withStyles(styles)(Search);
